import { IconEye, IconTimes, IconEyeHidden } from '../../../Components/shared/Icon'
import {
  setBombBombHidden,
  selectBombBombStep,
  selectBombBombHidden,
  selectBombBombStatus
} from '../../../store/slices/bombBomb'
import { useState } from 'react'
import classnames from 'classnames'
import { Button } from '../../../Components'
import { SAVE, SEND } from '../../../types/bombBomb'
import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { BombBombSaveForm } from '../BombBombSaveForm/BombBombSaveForm'
import { BombBombSendForm } from '../BombBombSendForm/BombBombSendForm'
import { BombBombPanelVideo } from './BombBombPanelVideo/BombBombPanelVideo'
import { BombBombCloseAlert } from '../BombBombCloseAlert/BombBombCloseAlert'

import styles from './BombBombPanelContent.module.scss'
import { FAILED } from '../../../types/loadingStatus'
import { BombBombPanelContentError } from './BombBombPanelContentError'

export const MSG = defineMessages({
  exitBtn: {
    id: 'BombBomb.panel.exitBtn.title',
    defaultMessage: 'Exit BombBomb'
  },
  hideBtn: {
    id: 'BombBomb.panel.hideBtn.title',
    defaultMessage: 'Hide BombBomb panel'
  },
  showBtn: {
    id: 'BombBomb.panel.showBtn.title',
    defaultMessage: 'Show BombBomb panel'
  }
})

export const BombBombPanelContent = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const step = useSelector(selectBombBombStep)
  const status = useSelector(selectBombBombStatus)
  const hidden = useSelector(selectBombBombHidden)
  const [isAlertOpen, setIsAlertOpen] = useState(false)

  return (
    <>
      <Button
        primary
        iconStart={hidden ? IconEye : IconEyeHidden}
        title={intl.formatMessage(hidden ? MSG.showBtn : MSG.hideBtn)}
        onClick={() => dispatch(setBombBombHidden(!hidden))}
        className={classnames(styles.hideBtn, hidden && styles.shifted)}
      />
      <Button
        danger
        primary
        iconStart={IconTimes}
        title={intl.formatMessage(MSG.exitBtn)}
        onClick={() => setIsAlertOpen(true)}
        className={classnames(styles.exitBtn, hidden && styles.hide)}
      />
      <div className={classnames(styles.container, hidden && styles.hide)}>
        <BombBombPanelVideo />
        {!isAlertOpen && step === SAVE && <BombBombSaveForm />}
        {!isAlertOpen && step === SEND && <BombBombSendForm />}
        {!isAlertOpen && status === FAILED && <BombBombPanelContentError />}
        {isAlertOpen && <BombBombCloseAlert setIsAlertOpen={setIsAlertOpen} />}
      </div>
    </>
  )
}
